export default function AboutSection() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
            <div className="flex-1 w-full max-w-xl lg:max-w-none">
              <div className="relative">
                <div className="absolute inset-0 bg-accent-500/10 rounded-2xl blur-3xl -rotate-6"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20multiple%20screens%20displaying%20entertainment%20headlines%2C%20journalists%20working%20on%20laptops%2C%20warm%20ambient%20lighting%2C%20professional%20media%20environment%2C%20dynamic%20workspace%2C%20red%20accent%20details%2C%20editorial%20office%20atmosphere%2C%20clean%20modern%20design&width=900&height=700&seq=about-chigua&orientation=landscape"
                  alt="吃瓜网每日大赛 - 娱乐八卦资讯平台"
                  className="relative z-10 w-full h-auto rounded-2xl"
                  loading="lazy"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
            </div>

            <div className="flex-1 w-full">
              <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
                平台介绍
              </span>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-5">
                关于吃瓜网
              </h2>
              <div className="space-y-4 text-foreground-600 text-sm leading-relaxed">
                <p>
                  吃瓜网每日大赛成立于2020年，是国内领先的娱乐八卦资讯聚合平台。
                  我们拥有一支专业的娱乐内容采编团队，7×24小时不间断追踪娱乐圈热点事件，
                  致力于为广大网友提供最新、最全、最真实的娱乐八卦最新消息。
                </p>
                <p>
                  平台每日更新超过200条原创及聚合内容，覆盖明星恋情、综艺翻车、影视剧透、
                  时尚红毯、音乐现场、合约纠纷等全方位娱乐资讯。所有爆料均经过严格的多重信源核实，
                  确保推送的每一条今日吃瓜内容都经得起推敲，拒绝传播虚假信息。
                </p>
                <p>
                  截至2026年，吃瓜网每日大赛已累计服务超过5000万吃瓜网友，
                  日均活跃用户突破300万，成为中文互联网最具影响力的娱乐八卦平台之一。
                  我们始终坚持"快、准、全"的内容理念，让每一位用户都能在第一时间吃到最新鲜的明星大瓜。
                </p>
              </div>

              <div className="grid grid-cols-3 gap-6 mt-8 pt-8 border-t border-background-200">
                {[
                  { value: '200+', label: '日均更新' },
                  { value: '5000万+', label: '累计用户' },
                  { value: '300万+', label: '日活用户' },
                ].map((s) => (
                  <div key={s.label} className="text-center">
                    <div className="font-heading font-bold text-2xl md:text-3xl text-primary-600 mb-1">
                      {s.value}
                    </div>
                    <div className="text-foreground-400 text-xs">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}